module.exports = __webpack_public_path__ + "static/media/stickerbackground.c3d67658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stickerbackground.png
// module id = 1979
// module chunks = 0